import React from 'react';
import classnames from 'classnames';
import { ConfigurableLink } from 'swag-client-common/components/utils/configurable-link';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import { OtherLinks } from '../other-links';
import classes from './account-dropdown.scss';
export const AccountDropdown = ({
  userRole,
  isOpen,
  onLogOut,
  className,
  useHardLinks,
  routeNavigationConfirmation,
  orderApprovalFlow = false,
  userIsHeadOfCompanyDepartment = false,
  inventoryId,
  isApiAccessEnabled,
  showInventoryLink
}) => {
  return isOpen && /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.container, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.innerContainer)
  }, /*#__PURE__*/React.createElement("ul", {
    className: classes.dropdownItemsContainer
  }, /*#__PURE__*/React.createElement(ConfigurableLink, {
    dataLink: "MyOrders",
    className: classes.dropdownItem,
    link: APP_ROUTES.ACCOUNT_ORDERS,
    isHardLink: useHardLinks,
    routeNavigationConfirmation: routeNavigationConfirmation
  }, "My orders"), /*#__PURE__*/React.createElement(OtherLinks, {
    userRole: userRole,
    useHardLinks: useHardLinks,
    routeNavigationConfirmation: routeNavigationConfirmation,
    orderApprovalFlow: orderApprovalFlow,
    userIsHeadOfCompanyDepartment: userIsHeadOfCompanyDepartment,
    inventoryId: inventoryId,
    isApiAccessEnabled: isApiAccessEnabled,
    showInventoryLink: showInventoryLink
  }), /*#__PURE__*/React.createElement(ConfigurableLink, {
    dataLink: "ProfileSettings",
    className: classes.dropdownItem,
    link: APP_ROUTES.PROFILE_SETTINGS,
    isHardLink: useHardLinks,
    routeNavigationConfirmation: routeNavigationConfirmation
  }, "Profile settings"), /*#__PURE__*/React.createElement(ConfigurableLink, {
    dataLink: "Logout",
    className: classnames(classes.dropdownItem, classes.actionElement),
    onClick: onLogOut,
    isHardLink: false,
    routeNavigationConfirmation: routeNavigationConfirmation
  }, "Logout"))));
};